<template>
	<div style="position: absolute; bottom: 10px; left: 50%; display: flex">
		<md-button v-if="show" class="md-elevation-4 button" @click="$emit('click')">
			<i class="el-icon-plus" style="margin-right: 2px" />
			<span style="margin: 0px 2px">{{ $t("add") }}</span>
		</md-button>
	</div>
</template>
<script>
export default {
	name: "add-button",
	props: ["show"]
}
</script>

<style scoped lang="scss">
.button {
	margin-left: auto;
	margin-right: auto;
	margin-top: auto;
	margin-bottom: auto;
	border-radius: 25px;
	background-color: #455a64;
	span,
	i {
		color: white;
	}
	font-family: "Montserrat", sans-serif;
}
</style>
